@if (!hasErrors()) {
    <big-ui-footer>
        <div footerContact>
            <big-ui-footer-menu
                [menu]="menus?.contact"
                [iconMap]="iconMap" />
        </div>

        <div footerAbout>
            <big-ui-footer-menu [menu]="menus?.about" />
        </div>

        <div footerLegal>
            <big-ui-footer-menu [menu]="menus?.legal" />
        </div>

        <div footerAccessibility>
            @if (menus?.accessibility; as menu) {
                <big-ui-footer-menu [menu]="menu" />
            }
        </div>

        <div footerLanguages>
            @if (menus?.languages; as menu) {
                <big-ui-footer-menu
                    [menu]="menu"
                    [alwaysExpanded]="true" />
            }
        </div>

        <div footerApps>
            @if (menus?.apps; as menu) {
                <big-ui-footer-menu
                    [orientation]="'horizontal'"
                    [headerClass]="'shrink-0'"
                    [listClass]="''"
                    [menu]="menus?.apps"
                    [iconMap]="iconMap" />
            }
        </div>

        <div footerSocial>
            @if (menus?.social) {
                <big-ui-footer-menu
                    [orientation]="'horizontal'"
                    [headerClass]="'sr-only'"
                    [listClass]="'lg:text-right'"
                    [menu]="menus?.social"
                    [iconMap]="iconMap" />
            }
        </div>
    </big-ui-footer>
}
